import { render, staticRenderFns } from "./TEMPLATE.vue?vue&type=template&id=cfcd545e&scoped=true"
import script from "./TEMPLATE.vue?vue&type=script&lang=js"
export * from "./TEMPLATE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcd545e",
  null
  
)

export default component.exports